jQuery(document).ready(function () {
  jQuery('.js-remove-parent-account').on('submit', function () {
    let buttonLabel = jQuery(this).find('.js-agendtheme-button__label').text();
    buttonLabel = buttonLabel[0].toLowerCase() + buttonLabel.substring(1);
    let message = 'Are you sure you want to ' + buttonLabel;
    let parentAccountName = jQuery(this).find('input[name="parent_account_name"]').val();
    if (parentAccountName) {
      message += ' from ' + parentAccountName + '?';
    } else {
      message += '?';
    }
    return confirm(message);
  });
});
